import { useCallback, useEffect, useState } from "react";
import { request } from "../../httpClient";

export const useArticleData = (id: any) => {
  const [articleData, setArticleData] = useState({});
  const [articleDataLoading, setArticleDataLoading] = useState(true);

  const getArticleData = useCallback(async (id: any) => {
    setArticleDataLoading(true);
    const res = await request({
      path: `article/get-data?article_id=${id}`,
    });
    setArticleData(res?.data);
    setArticleDataLoading(false);
    return res?.data;
  }, []);

  useEffect(() => {
    if (id) {
      getArticleData(id);
    } else {
      setArticleDataLoading(false);
    }
  }, [id, getArticleData]);

  return { articleData, articleDataLoading, getArticleData };
};
